import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

import { setIsShowTNCDialog } from "../../../../../redux/layout/layoutActions";

export const TncDialog = React.memo(() => {
  const scroll = "paper";

  const [isCheckedDisable, setIsCheckedDisable] = useState(false);

  const [isBottomReached, setIsBottomReached] = useState(false);

  const dispatch = useDispatch();

  // Getting current state of layout from store (Redux)
  const { currentLayoutState } = useSelector(
    state => ({ currentLayoutState: state.layout }),
    shallowEqual,
  );

  const { isShowTNCDialog } = currentLayoutState;

  const handleClose = () => dispatch(setIsShowTNCDialog(false));

  const handleAgreedAction = value => {
    setIsCheckedDisable(true);
    handleCloseFunc();
  };

  const handleCloseFunc = value => {
    handleClose();
    setIsBottomReached(false);
  };

  const handleScroll = event => {
    const bottom =
      event.target.offsetHeight + event.target.scrollTop >=
      event.target.scrollHeight;

    if (bottom) {
      setIsBottomReached(true);
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="title"
      aria-describedby="description"
      open={isShowTNCDialog}
      scroll={scroll}
    >
      <DialogTitle id="title">Term & condition</DialogTitle>
      <DialogContent dividers={scroll === "paper"} onScroll={handleScroll}>
        {[...new Array(10)].map(
          () =>
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        )}
      </DialogContent>
      <DialogActions className="terms">
        <Modal.Footer className="w-100">
          <Button
            onClick={handleAgreedAction}
            disabled={!isBottomReached}
            className="btn btn-primary btn-elevate"
          >
            Agree
          </Button>
          <Button onClick={handleClose} className="btn btn-light btn-elevate">
            Cancel
          </Button>

          <Button
            onClick={() => window.print()}
            className="btn btn-light btn-elevate"
          >
            PRINT
          </Button>
        </Modal.Footer>
      </DialogActions>
    </Dialog>
  );
});
